import { createModelId } from "@core/foundation/model";

import { ID_PREFIX } from "./id-prefix.ts";

const { generateId: generateRevisionId, idSchema: RevisionIdSchema } =
  createModelId({ idPrefix: ID_PREFIX.REVISION });

export { RevisionIdSchema, generateRevisionId };
